enum CallIntegrationType {
  AIRCALL = 'Aircall',
  HubspotPhone = 'HubspotPhone',
  None = 'None',
  Twilio = 'Twilio',
  Ringover = 'Ringover',
}

export default CallIntegrationType;
